import { render, staticRenderFns } from "./ColumnUploadFiles.vue?vue&type=template&id=727a5e08"
import script from "./ColumnUploadFiles.vue?vue&type=script&lang=ts"
export * from "./ColumnUploadFiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports